import * as React from "react";
import { EcgTest } from "webportalclient";
import { DateTimeAccuracy, LocalizedDateTime } from "../misc/components/LocalizedDateTime";

export interface EcgResultsPanelProps {
    test: EcgTest;
    isQC: boolean;
    controls?: React.ReactNode;
    children?: React.ReactNode;
}

export const EcgResultsPanel = ({ test, isQC, controls, children } : EcgResultsPanelProps) => {
    return (
        <div className="panel panel-default">
            <div className="panel-body">
                <table id="ResultsTable" className="table table-striped">
                    <thead>
                        <tr>
                            <th />
                            <th>
                                Recording {test.index}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {!isQC ? <tr>
                            <td><b>Time</b></td>
                            <td key={`TestDateTime${test.id}`}>
                                <LocalizedDateTime
                                    time={test.occurred}
                                    accuracy={DateTimeAccuracy.Second}
                                />
                            </td>
                        </tr> : null}
                        {controls}
                    </tbody>
                </table>
                {children}
            </div>
        </div>
    );
}
